import React from "react"
import { Map } from "lucide-react"
import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { useTranslation } from "react-i18next"

type ShowDesktopMapButtonProps = {
  onShow: () => void
  className?: string
}

const ShowDesktopMapButton: React.FC<ShowDesktopMapButtonProps> = ({
  onShow,
  className,
}) => {
  const { t } = useTranslation()
  return (
    <motion.div
      className="absolute right-5 top-[10px] z-[99]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
    >
      <Button
        variant="floating"
        size="floating"
        onClick={onShow}
        aria-label={t("maps.showDesktopMapButton.showMap")}
        title={t("maps.showDesktopMapButton.showMap")}
        id="desktopShowMapButton"
        className={cn("shadow-lg", className)}
      >
        <Map size={20} />
      </Button>
    </motion.div>
  )
}

export default ShowDesktopMapButton
